import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  align: 'center',
})`
  width: 320px;

  & > div {
    width: 100%;
    & > div {
      width: 100%;
    }
  }
`;
